import { ConfiguratorHeader } from "~/app/shell/ConfiguratorHeader";
import { useConfiguratorViewModel } from "~/features/configurator-v2/common/application/useConfiguratorViewModel";
import type { ConfiguratorDefinition } from "~/features/configurator-v2/common/contract/definition";

/**
 * Shell-only module: the timeline configurator header that replaces the
 * standard storefront header on the four LinearConfigurator routes. Imported
 * by `__root` (entry-safe: the pre-migration route file already carried it in
 * the main bundle) — NOT by the route component module, so the header does not
 * pull the configurator page tree into the entry chunk either.
 */

export function TimelineConfiguratorHeader({ definition }: { definition: ConfiguratorDefinition }) {
  const viewModel = useConfiguratorViewModel(definition);

  return viewModel.configuration && viewModel.context ? (
    <ConfiguratorHeader
      configuration={viewModel.configuration}
      context={viewModel.context}
      complete={viewModel.complete}
      titleKey={definition.titleKey}
    />
  ) : null;
}
